import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://ehlxcpfqnuaxajaetnwi.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVobHhjcGZxbnVheGFqYWV0bndpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3MDk5MzEsImV4cCI6MjA4NTI4NTkzMX0.W1XClpYPyGIMg4vPYhsnYpPaNkvhJezwII-7hR6E_wg'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})